import {useState} from 'react';
import {useParams} from 'react-router-dom';
import {Card, Container, Rating, Stack, Typography} from '@mui/material';
import {toast} from 'react-toastify';
import Page from 'src/components/Page';
import DynamicList from 'src/components/DynamicList';
import DeleteAlertDialog from 'src/components/modals/DeleteAlertDialog';
import PublishSwitch from 'src/pages/products/common/PublishSwitch';
import {request} from 'src/utils/AdminApi';
import {handleRequestError} from 'src/utils/helperMethods';

export default function ReviewsPage() {
	const {id: productId} = useParams();
	const api_route = productId ? `/reviews?product=${productId}` : '/reviews';

	return (
		<Page title="التقييمات">
			<Container maxWidth="md">
				<Card sx={{p: 3}}>
					<Stack spacing={2}>
						<Typography variant="h4">التقييمات</Typography>
						<DynamicList api_route={api_route} RowComponent={ReviewRow} />
					</Stack>
				</Card>
			</Container>
		</Page>
	);
}

function ReviewRow({item, refetch}) {
	const [loading, setLoading] = useState(false);

	const handlePublishChange = async (date) => {
		setLoading(true);
		try {
			await request(`/reviews/${item.id}`, 'PUT', {published_at: date});
			toast.success(date ? 'تم نشر التقييم' : 'تم الغاء نشر التقييم');
			refetch();
		} catch (err) {
			toast.error(handleRequestError(err));
		} finally {
			setLoading(false);
		}
	};

	const handleDelete = async () => {
		try {
			await request(`/reviews/${item.id}`, 'DELETE');
			toast.success('تم الحذف بنجاح');
			refetch();
		} catch (err) {
			toast.error(handleRequestError(err));
		}
	};

	return (
		<Card variant="outlined" sx={{p: 3}}>
			<Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
				<Stack sx={{flexGrow: 1}}>
					<Stack direction="row" spacing={1} alignItems="center">
						<Typography variant="subtitle2">{item.customer_name ?? 'زائر'}</Typography>
						<Rating value={item.rating} readOnly size="small" />
					</Stack>
					<Typography variant="caption" color="text.secondary">
						{item.product?.name}
					</Typography>
					<Typography variant="body2">{item.comment ?? 'لا يوجد ملاحظات'}</Typography>
				</Stack>
				<Stack direction="row" spacing={1} alignItems="center">
					<PublishSwitch
						value={!!item.published_at}
						onChange={handlePublishChange}
						sx={{opacity: loading ? 0.5 : 1}}
						label="منشور"
						infoTitle="سيتم عرض التقييم في المتجر إذا تم تفعيل هذا الخيار"
					/>
					<DeleteAlertDialog onDelete={handleDelete} />
				</Stack>
			</Stack>
		</Card>
	);
}
